/*
 * Kinetic Workspaces — conversion instrumentation
 *
 * Pushes a vendor-neutral dataLayer so Google Tag Manager (and through it GA4 and
 * Google Ads) has micro-conversions to optimise on. On a low-volume, higher-ticket
 * catalogue the purchase event alone never reaches the volume Smart Bidding needs,
 * so the signals that matter are the ones before it: product views, add to cart,
 * checkout starts, CTA clicks and read depth.
 *
 * This file only produces events. No tag, no pixel and no identifier is loaded here.
 * Connect a container (GTM) and map these events to conversions there.
 *
 * Consent: nothing in this file writes cookies or contacts a third party. Consent
 * gating belongs to whatever container consumes the dataLayer.
 */

(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  var push = function (event, payload) {
    var data = { event: event };
    for (var key in payload) {
      if (Object.prototype.hasOwnProperty.call(payload, key)) data[key] = payload[key];
    }
    window.dataLayer.push(data);
  };

  var meta = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) || {};
  var page = meta.page || {};

  /* Shopify's cart endpoints do not return a currency on every response, and GA4
     rejects a value without one. Fall back to the storefront's active currency. */
  var activeCurrency = function () {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || null;
  };

  var money = function (cents) {
    return typeof cents === 'number' ? Math.round(cents) / 100 : null;
  };

  push('kw_page_view', {
    page_type: page.pageType || 'unknown',
    resource_id: page.resourceId || null,
    currency: activeCurrency(),
  });

  if (page.pageType === 'product' && meta.product) {
    var variant = (meta.product.variants && meta.product.variants[0]) || {};
    push('view_item', {
      currency: activeCurrency(),
      value: money(variant.price),
      items: [
        {
          item_id: String(meta.product.id || ''),
          item_name: meta.product.type || document.title,
          item_variant: variant.name || null,
          price: money(variant.price),
          quantity: 1,
        },
      ],
    });
  }

  /* The theme adds to cart through fetch(). Wrapping fetch catches every path —
     product form, quick add, cart drawer — without touching theme code. */

  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isAdd = url.indexOf('/cart/add') !== -1;

      return nativeFetch.apply(this, arguments).then(function (response) {
        if (!isAdd || !response.ok) return response;

        response
          .clone()
          .json()
          .then(function (body) {
            var lines = body && body.items ? body.items : [body];
            var total = 0;
            var items = lines.filter(Boolean).map(function (line) {
              total += (line.final_line_price || line.line_price || 0) / 100;
              return {
                item_id: String(line.product_id || ''),
                item_name: line.product_title || line.title || '',
                item_variant: line.variant_title || null,
                price: money(line.final_price || line.price),
                quantity: line.quantity || 1,
              };
            });

            push('add_to_cart', {
              currency: (body && body.currency) || activeCurrency(),
              value: Math.round(total * 100) / 100,
              items: items,
            });
          })
          .catch(function () {
            /* a malformed cart response must never break the page */
          });

        return response;
      });
    };
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!event.target || !event.target.closest) return;

      var checkout = event.target.closest(
        'button[name="checkout"], .cart__checkout-button, [href*="/checkout"]'
      );
      if (!checkout) return;

      var cartTotal = document.querySelector('.totals__total-value');
      push('begin_checkout', {
        currency: activeCurrency(),
        value_text: cartTotal ? cartTotal.textContent.trim() : null,
        origin: checkout.closest('cart-drawer') ? 'drawer' : 'cart_page',
      });
    },
    true
  );

  /* CTA clicks, labelled by where on the page the click happened, so the hero CTA
     can be told apart from the mid-page and closing ones. */

  document.addEventListener(
    'click',
    function (event) {
      if (!event.target || !event.target.closest) return;

      var cta = event.target.closest('.kinetic-btn, .kph-cta, .kps-cta, .button--primary');
      if (!cta) return;

      var position = cta.closest('.kinetic-hero')
        ? 'hero'
        : cta.getBoundingClientRect().top + window.scrollY > document.body.scrollHeight * 0.66
        ? 'closing'
        : 'mid_page';

      push('kw_cta_click', {
        cta_text: (cta.textContent || '').trim().slice(0, 80),
        cta_href: cta.getAttribute('href') || null,
        cta_position: position,
      });
    },
    true
  );

  /* Read depth. On a long landing page this is the only signal that separates a
     bounce from someone who actually read the argument. Fires once per threshold. */

  var thresholds = [25, 50, 75, 90];
  var reached = {};

  var onScroll = function () {
    var doc = document.documentElement;
    var scrollable = doc.scrollHeight - window.innerHeight;
    if (scrollable <= 0) return;

    var percent = ((window.scrollY || doc.scrollTop) / scrollable) * 100;

    thresholds.forEach(function (mark) {
      if (percent >= mark && !reached[mark]) {
        reached[mark] = true;
        push('kw_scroll_depth', { percent: mark });
      }
    });

    if (reached[90]) window.removeEventListener('scroll', onScroll);
  };

  window.addEventListener('scroll', onScroll, { passive: true });

  window.setTimeout(function () {
    push('kw_engaged_60s', { page_type: page.pageType || 'unknown' });
  }, 60000);
})();
